// bt-common/engine/engine-classifiers.ts
// #922 S0a: typed READ classifiers over persisted legacy values. Unknown input => 'unknown' (callers
// count it), never silently mapped. Only the explicit `messagelogs.clientType` 'cloud-api' (#1083) classifies to 'cloud-api'; sessions never do.
import type { EngineKind } from './engine-kind';
import { ENGINE_DESCRIPTORS, type EngineDescriptor } from './engine-descriptor';
import type { SendFailEngine } from './send-failure';

export type ClassifiedKind = EngineKind | 'unknown';

/** `messagelogs.clientType` -> kind. `whatsapp`/`frontend`/`extension-content` are the browser extension. */
export function kindFromClientType(v: unknown): ClassifiedKind {
    switch (v) {
        case 'baileys-pod': return 'baileys';
        case 'gateway': return 'chrome-gateway';
        case 'cloud-api': return 'cloud-api';
        case 'whatsapp':
        case 'frontend':
        case 'extension-content': return 'extension';
        default: return 'unknown';
    }
}

/** `sessions.engineType` ONLY (null/undefined/'legacy'/other => 'unknown'). */
export function kindFromEngineType(v: unknown): ClassifiedKind {
    if (v === 'baileys-pod') return 'baileys';
    if (v === 'session-pod') return 'chrome-gateway';
    return 'unknown';
}

/** `sessions.gatewayType` ONLY (`wa-js` is legacy data; '' / null => 'unknown'). */
export function kindFromGatewayType(v: unknown): ClassifiedKind {
    if (v === 'baileys') return 'baileys';
    if (v === 'wa-js-gcp' || v === 'wa-js') return 'chrome-gateway';
    return 'unknown';
}

/** A sessions doc: engineType wins, gatewayType is the fallback. */
export function kindFromSession(doc: { engineType?: unknown; gatewayType?: unknown } | null | undefined): ClassifiedKind {
    const byType = kindFromEngineType(doc?.engineType);
    return byType !== 'unknown' ? byType : kindFromGatewayType(doc?.gatewayType);
}

/** The §1.4 failure-record engine for a `clientType` (replaces send-protocol `engineOfClientType`). */
export function failEngineFromClientType(v: unknown): SendFailEngine {
    const kind = kindFromClientType(v);
    if (kind === 'unknown') return 'unknown';
    const d: EngineDescriptor = ENGINE_DESCRIPTORS[kind];
    return d.legacy ? d.legacy.failEngine : 'unknown';
}

